/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.0.1
 */

import { Fragment } from 'react';

import moment from 'moment';

import { LayoutStyled } from '../../../../../../components/common/Block/Layout';
import { IPageDashboardTranslation } from '../../../../../../modules/internationalization/types';
import ICommonTranslation from '../../../../../../modules/internationalization/types/common';
import { formatBalance } from '../../../../../../utils/formatText';
import { EFormatData } from '../../../../types/widgetTypes';
import { WidgetListItem } from '../../styled/WidgetStyled';
import {
    WidgetSubscriberMaxCostsListItemLeftStyled,
} from '../../WidgetSubscribersMaxCosts/styled/widgetSubscriberMaxCostsStyled';
import {
    WidgetPaymentHistoryListItemPaymentTypeStyled,
    WidgetPaymentHistoryListItemRightStyled,
} from '../styled/widgetPaymentHistoryStyled';
import { IPaymentsHistoryItem } from '../widgetPaymentHistoryTypes';

interface IWidgetPaymentHistorySuccessListProps {
    payments: IPaymentsHistoryItem[];
    translation: IPageDashboardTranslation & ICommonTranslation;
}

const WidgetPaymentHistorySuccessList = (props: IWidgetPaymentHistorySuccessListProps) => {
    const { payments, translation } = props;
    return (
        <Fragment>
            {
                payments.map((item: IPaymentsHistoryItem) =>
                    <WidgetListItem
                        key={item.amount + item.paymentDate}
                    >
                        <WidgetSubscriberMaxCostsListItemLeftStyled>
                            <LayoutStyled>
                                {formatBalance(item.amount)}&nbsp;{translation.currency}
                            </LayoutStyled>
                            <WidgetPaymentHistoryListItemPaymentTypeStyled>
                                {item.paymentType}
                            </WidgetPaymentHistoryListItemPaymentTypeStyled>
                        </WidgetSubscriberMaxCostsListItemLeftStyled>
                        <WidgetPaymentHistoryListItemRightStyled>
                            {moment(item.paymentDate).format(EFormatData.FullData)}
                        </WidgetPaymentHistoryListItemRightStyled>
                    </WidgetListItem>,
                )
            }
        </Fragment>
    );
};

export default WidgetPaymentHistorySuccessList;
